export default "data:image/webp;base64,UklGRj4AAABXRUJQVlA4IDIAAAAQBACdASpIAEgAPpFIoUylpCMiIUgAsBIJaQAACfGjRo0aNGjRo0Z+AAD+8oAAAAAAAA=="